/*!
 * FG Forrest :: TWO COMPONENT PRICE CALCULATOR v1.0.0
 * Date: 2017-02-28T13:14Z
 */
var $ = require('jquery');
var numeral = require('./numeral');

"use strict";

var PLUGIN_NAME = "twoComponentPriceCalculator";
var PLUGIN_VERSION = "v1.0.0";
var PLUGIN_AUTHOR = "Tomáš Hospodka";

var DEFAULTS = {
	calculator: 'priceCalculator',
	calculatorForm: 'priceCalculatorForm', // id formu kalkulačky
	calculatorResult: 'priceCalculatorResult', // id result bloku kalkulačky
	calculatorConsumptionContainer: 'priceCalculatorFormConsumptionContainer', // id form-group
	calculatorMessages: 'calculatorFormMessages',  // id help-block
	classResult: 'price-calculator-results--open', // css třída pro open result bloku
	classError: 'has-error', // css třída pro error
	consumptionId: 'consumption', // spotřeba
	singleId: 'single', // cena jednosložková
	variableId: 'variable', // cena pohyblivá složka
	solidId: 'solid', // cena pevná složka
	errorMessage: 'Neplatná hodnota. Zadejte spotřebu jako číslo od 1 do 360.', // chybová hláška při nevalidním vstupu pod hodnotu 360 m3
	errorMessageOver999: 'Roční odběry vyšší než 360 m3 odpovídají zařazení do vyšší kategorie pevné složky. Konkrétní kategorii zjistíte na stránce Dvousložková cena nebo dotazem na zákaznické centrum.', // chybová hláška při nevalidním vstupu nad hodnotu 360 m3
	debugEnabled: true
};

/**
 * Plugin constructor
 *
 * @param element
 * @param options
 * @constructor
 */
function TwoComponentPriceCalculator(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;
	this.initialise();
}

/**
 * Inicializace pluginu
 * - použití po startu pluginu a po výměně obsahu a filtrů
 */
TwoComponentPriceCalculator.prototype.initialise = function () {

	// nabindujeme eventy
	this.bindEvents();

	// ukončíme inicializaci vystřelením eventu
	this.endInitialise($(this.element));

};

/**
 * Nastavení odchytávání eventů
 */
TwoComponentPriceCalculator.prototype.bindEvents = function () {
	var self = this, o = self.options,
			$form = $("#" + o.calculatorForm),
			$consumption = $("#" + o.consumptionId),
			$formMessages = $("#" + o.calculatorMessages),
			$formConsumptionContainer = $("#"+o.calculatorConsumptionContainer);

	// sledování odeslání formu
	if ($form.length > 0) {
		$form.on('submit', function (e) {
			e.preventDefault();
			// odstraníme error pokud by zůstal z předchozího požadavku
			$formConsumptionContainer.removeClass(o.classError);
			// a zrušíme message
			$formMessages.html('');
			// provedeme formát vstupu
			var val = ($consumption.val().replace(/\s/g, "").replace(',', '.')*1);
			// zformátovanou hodnotu vložíme do formu, aby uživatel věděl
			if(val > 0) {
				$consumption.val(val).focus();
			} else {
				$consumption.val('').focus();
			}
			// provedeme výpočet
			if ($.isNumeric(val) && val>0 && val<361) {
				self.calculation(val);
			} else {
				// označíme jako error
				if (!$formConsumptionContainer.hasClass(o.classError)) {
					$formConsumptionContainer.addClass(o.classError);
				}
				// zapíšeme message
				if ($.isNumeric(val) && val>360) {
					$formMessages.html(o.errorMessageOver999);
				} else {
					$formMessages.html(o.errorMessage);
				}
			}
			//- self.log($form,"právě byl odeslán tento form: "+o.calculatorForm);
		});
	}

};

/**
 * Provedení výpočtu
 */
TwoComponentPriceCalculator.prototype.calculation = function (val) {
	var self = this, o = self.options, calculationData = [],
			$single = ($("#" + o.singleId).val().replace(',', '.'))*1,
			$variable = ($("#" + o.variableId).val().replace(',', '.'))*1,
			$solid = ($("#" + o.solidId).val().replace(',', '.'))*1,
			$consumption = val*1;

	// platba za rok jednosložková
	calculationData['paymentYearOne'] =  $consumption * $single;
	// cena za m3  jednosložková
	calculationData['paymentPerMOne'] = $single;
	// platba za rok dvousložková
	calculationData['paymentYearTwo'] = ($consumption * $variable) + $solid;
	// cena za m3 dvousložková
	calculationData['paymentPerMTwo'] = $variable;
	// pevná složka
	calculationData['paymentFixedPrice'] = $solid;
	// spotřeba
	calculationData['consumption'] = $consumption;
	// ušetřeno
	calculationData['saving'] = calculationData['paymentYearOne'] - calculationData['paymentYearTwo'];

	//- self.log(calculationData,"vypočítaná data");

	// provedeme zobrazení výsledků
	self.writeResults(calculationData);
};

/**
 * Zobrazení výsledků
 */
TwoComponentPriceCalculator.prototype.writeResults = function (data) {
	var self = this, o = self.options,
		resultBlock = $("#"+o.calculatorResult),
		openClass = o.classResult;
	//- self.log(data,"data k zobrazení");

	// zformátujeme vypočítaná data a zapíšeme do daných bloků
	//-- Jednosložková forma ceny
	$("#resultPaymentYearOne").html(numeral(data['paymentYearOne']).format('0,0'));
	$("#resultPaymentPerMOne").html(numeral(data['paymentPerMOne']).format('0,0.00'));
	//-- Dvousložková forma ceny
	$("#resultPaymentYearTwo").html(numeral(data['paymentYearTwo']).format('0,0'));
	$("#resultPaymentPerMTwo").html(numeral(data['paymentPerMTwo']).format('0,0.00'));
	$("#resultPaymentFixedPrice").html(numeral(data['paymentFixedPrice']).format('0,0'));
	//-- result info summary
	$("#resultConsumption").html(numeral(data['consumption']).format('0,0.0'));
	// připravíme info textaci dle výsledku
	// musíme však odečíst úsporu/ztrátu až dle zaokrouhlených čísel, jinak nám to ve výsledku nebude sedět
	//- var saving = numeral(data['saving']).format('0,0')*1,
	var saving = Math.round(data['paymentYearOne']) - Math.round(data['paymentYearTwo']),
		savingString = "";
	if(saving === 0) {
		savingString = "<strong>stejně</strong> jako při";
	} else if(saving<0) {
		savingString = "<strong>o&nbsp;"+Math.abs(saving)+"&nbsp;Kč více</strong> než při";
	} else {
		savingString = "<strong>o&nbsp;"+saving+"&nbsp;Kč méně</strong> než při";
	}
	$("#resultSaving").html(savingString);

	// zobrazíme blok s výsledky
	if (!resultBlock.hasClass(openClass)) {
		resultBlock.slideDown( 1000, function() {
			resultBlock.addClass(o.class);
			self.scrollTo("#" + o.calculatorResult);
		});
	} else {
		self.scrollTo("#" + o.calculatorResult);
	}

};

/**
 * Helper funkce
 * - pro vystřelení eventu po inicializaci
 */
TwoComponentPriceCalculator.prototype.endInitialise = function () {
	var self = this;
	setTimeout(function () {
		$(self.element).trigger("twoComponentPriceCalculator:afterInit", {obj: self});
	}, 100);
};

/**
 * Helper funkce
 * - scroll
 */
TwoComponentPriceCalculator.prototype.scrollTo = function (destination) {
	$('html, body').animate({
			scrollTop: $(destination).offset().top
	}, 500);
};

/**
 * Helper funkce
 * - vrátí true pokud je proměnná pole
 *
 * @returns {bool}
 */
TwoComponentPriceCalculator.prototype.isArray = function (a) {
	if (Object.prototype.toString.call(a) == '[object Array]') {
		return true;
	} else {
		return false;
	}
};

/**
 * Helper funkce
 * - vrátí pole aktualizované o požadovanou hodnotu
 *
 * @returns {bool}
 */
TwoComponentPriceCalculator.prototype.pushToArray = function (a, v) {
	if (this.isArray(a)) {
		a.push(v);
		return a;
	} else {
		return false;
	}
};

/**
 * Helper funkce
 * - write log console for debug scripts
 */
TwoComponentPriceCalculator.prototype.log = function (l, msg) {
	var self = this, o = self.options;
	if (typeof(msg) !== 'string') msg = '-';
	if (o.debugEnabled && window.console) {
		console.log(l);
		console.log('-- Debug: ' + msg + ' :End --');
	}
};

/**
 * decide, which methods will be "public"
 *
 *    $(JQ_object).PLUGIN_NAME( 'action', { param:"value" } );
 */
var API = {
	initialise: TwoComponentPriceCalculator.prototype.initialise
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *        if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *        if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new TwoComponentPriceCalculator(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/twoComponentPriceCalculator.js